/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentCandidateUntemplated/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AppointmentCandidateUntemplated({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/AppointmentCandidateUntemplated"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsRed700alpha50 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700alpha.50'
        })
let dtColorsRed700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventValueData = fromData.useDataFormat({ viewPath,
context: 'event',
format: fromFormat.formatTimegridAppointmentTime,
})
let eventDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'description',
})
  return (<React.Fragment
>
<div
  data-testid="AppointmentCandidateUntemplated.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-1-oEjwy': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-2-oEjwy': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-3-oEjwy': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-4-oEjwy': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-5-oEjwy': dtColorsRed700alpha50,'--bc-6-oEjwy': dtColorsRed700}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AppointmentCandidateUntemplated.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-7-oEjwy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-8-oEjwy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-oEjwy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-10-oEjwy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="AppointmentCandidateUntemplated.Vertical:2"
  data-view-path={viewPath}
 style={{'--r-11-oEjwy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaIconClose
  viewPath={`${viewPath}/TysiaIconClose`}
 fill={dtColorsWhite}
 width={dtSpaceS}
 height={dtSpaceS}
/>
</div>
<div
  data-testid="AppointmentCandidateUntemplated.Vertical:3"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="event"
 format="/Data/format.js formatTimegridAppointmentTime"
 text={eventValueData}
 weight="medium"
 size="small"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="event.description"
 text={eventDescriptionValueData}
 weight="medium"
 size="small"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}